<template>
  <div class="preview-information">
    <header-top showBack></header-top>
    <div class="header-title show-back">{{headerText}}</div>
    <el-row class="preview">
      <div class="device-box">
        <div
          class="device"
          :class="{ active: device == 'phone' }"
          @click="getDevice('phone')"
        >
          <i class="el-icon-mobile-phone"></i> 手机
        </div>
        <div
          class="device"
          :class="{ active: device == 'PC' }"
          @click="getDevice('PC')"
        >
          <i class="el-icon-monitor"></i> 电脑
        </div>
      </div>
      <el-col :sm="24" :md="24" v-if="device == 'PC'">
        <div class="article-container">
          <div class="article-detail">
            <p>
              {{ information.name }}
            </p>
            <div>
              <div
                v-if="information.content != null && information.content != ''"
                 class="ck-content"
                v-html="information.content"
              />
              <div v-else class="ql-editor none-content">
                资讯正文暂无内容，快去添加吧~
              </div>
            </div>
          </div>
        </div>
      </el-col>
      <el-col :sm="24" :md="24" v-else>
        <div class="phone-container">
          <img src="@/assets/image/phone-bg.png" class="phone-bg" alt="" />
          <div class="container">
            <p>
              {{ information.name }}
            </p>
            <div class="ql-snow">
              <div
                v-if="information.content != null && information.content != ''"
                class="ql-editor"
                v-html="information.content"
              />
              <div v-else class="ql-editor none-content">
                资讯正文暂无内容，快去添加吧~
              </div>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import headerTop from "@/components/HeaderTop";
import { getInformation } from "@/http/api/information";
export default {
  // props: ['information', 'articleCover'],
  components: {
    headerTop,
  },
  data() {
    return {
      id: this.$route.params.id,
      headerText: "资讯预览",
      user: this.$store.getters.user,
      information: {},
      loading: false,
      // ReviewStatus:[],
      // reviewStatus:'',
      searchName: "",
      device: "PC",
    };
  },
  computed: {
    courseTypes() {
      return [];
    },
  },
  mounted() {
    this.getInformation();
  },
  methods: {
    getDevice(val) {
      this.device = val;
    },
    getInformation() {
      getInformation(this.id).then((res) => {
        if (res && res.result) {
          this.information = res.result;
        }
      });
    },
    articleMore(value) {
      //  this.$store.commit('SET_USERTABSNAME',value);
    },
  },
};
</script>

<style lang='scss' scoped>
@import "@/styles/mixin.scss";
@import "@/styles/ckedit5.scss";
.preview-information {
  .device-box {
    @include flex(row, center);
    box-shadow: 0px 2px 3px 0px rgba(0, 0, 0, 0.04);
    width: 150px;
    margin: 0 auto;
    .device {
      padding: 11px 13px;
      margin: 0 1px;
      cursor: pointer;
      font-size: 12px;
      background: #fff;
      i {
        font-size: 16px;
      }
    }
    .active {
      color: #2672ff;
    }
  }
  .preview {
    margin: 20px auto;
    padding: 20px;
    width: 1200px;
    background: #fff;

    .article-container {
      border: solid 1px #ededed;
      min-height: 750px;

      .article-detail {
        width: 100%;

        ::v-deep .ck-content {
          padding: 15px;
          .image {
              margin: 0;
              img {
                max-width: 100%;
                height: auto;
              }
            }
        }

        .none-content {
          line-height: 600px;
          text-align: center;
          font-size: 20px;
          color: #999;
        }

        p {
          border-bottom: 1px solid #e6e6e6;
          padding: 15px;
          font-size: 16px;
          text-align: center;
        }
      }
    }
    .phone-container {
      position: relative;
      margin: 20px auto;
      width: 350px;
      min-height: 150vh;
      .phone-bg {
        position: absolute;
        top: 0;
        left: 0;
        width: 350px;
        height: auto;
      }
      .container {
        position: absolute;
        top: 70px;
        left: 25px;
        z-index: 10;
        overflow-y: auto;
        overflow-x: hidden;
        width: 300px;
        height: 535px;
        background: #fff;

        .none-content {
          line-height: 600px;
          text-align: center;
          font-size: 20px;
          color: #999;
        background: #fff;
        }

        p {
          border-bottom: 1px solid #e6e6e6;
          padding: 15px;
          font-size: 16px;
          text-align: center;
        }
        ::v-deep .image {
              margin: 0;
              img {
                width: 100%;
                height: 100%;
              }
            }

        .ql-snow {
          border: 0;

          .ql-editor {
            margin: 15px;
            line-height: 25px;
            
          }
        }
      }
    }
  }
}
</style>
